export type HandwrittenArrowProps = {
  position: string;
};

export function HandwrittenArrow(props: HandwrittenArrowProps) {
  const { position } = props;

  const rotationMap: Record<string, number> = {
    top: 90,
    bottom: 180,
    left: 0,
    right: 200,
    'top left': 45,
    'bottom left': -45,
    'bottom right': 45,
    'top right': 140,
  };

  // Define some positioning styles based on the given position.
  // These values can be adjusted to fit your layout.

  const rotation = rotationMap[position] || 0;

  // Merge the base positioning transform (if any) with our rotation.
  const combinedTransform = `rotate(${rotation}deg)`;

  return (
    <svg
      className='handwritten-arrow'
      width='50'
      height='50'
      viewBox='0 0 30 30'
      style={{
        transform: combinedTransform,
      }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* A curved line with a “sketched” dash style */}
      <path
        d='M5 15 Q15 10 25 15'
        stroke='pink'
        strokeWidth='2'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='4 2'
      />
      {/* The arrowhead */}
      <path
        d='M20 10 L25 15 L20 20'
        stroke='pink'
        strokeWidth='2'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='4 2'
      />
    </svg>
  );
}

export default HandwrittenArrow;
